<template>
    <div>
        <div v-if="!app.isSpinnerVisible">
           <configurator30-component 
                v-if="app.currentConfiguration.configurator.id=='30-esp_trabajo'"/>
            <generic-configurator-component v-else />
        </div>
    </div>
</template>


<style lang="scss">

</style>


<script>
import { app } from "../../application.js";
import editParameterValueComponent from "../editParameterValue.vue";
import genericConfiguratorComponent from "./genericConfigurator.vue";
import configurator30Component from "./configurator30.vue";

export default {
    name: "productFamiliesComponent",
    data() {
        return {
            app: app,
            beforeRouteLeaveResolved: false,
            window_width: window.innerWidth
        };
    },
    components: { 
        editParameterValueComponent, 
        genericConfiguratorComponent,
        configurator30Component
    },
    methods: {

        clean: function(selected_attribute_name) {
            var familyParams = this.app.currentConfiguration.familyParameters;

            Object.values(familyParams).map(parameter => {
                if (parameter.attribute.name == selected_attribute_name) {
                    if (parameter.value.constructor.name == "Array") {
                        parameter.value = [];
                    } else {
                        parameter.value = "";
                    }
                }
            });

            this.refreshParameters();
        },
        cleanAllSelectors: function() {
            //loop through familyParameters values resetting all selected values in currentConfiguration.familyParameters
            let famParams = this.app.currentConfiguration.familyParameters;
            Object.values(famParams).map(item => {
                if(typeof item.value !== 'undefined'){
                    
                    if (item.value.constructor.name == "Array") {
                        item.value = [];
                    } else {
                        item.value = "";
                    }

                }
            });
            this.$emit("clearCheckboxes");
            this.refreshParameters();
        },
        refreshParameters: async function() {
            await this.app.asyncProcess(false, false);
            
        },
        tryNavigateToMainElement: function() {
            //crida la funcio check on si la resposta del servidor es correcte redirigeix a la pantalla 3, sino mostra error
            this.app.navigateToNextStage();
        },
        updateWindowSize() {
            this.window_width = window.innerWidth;
        }
    },

    async beforeMount() {
        
    },

    created() {        
        window.addEventListener("resize", this.updateWindowSize);
        this.updateWindowSize();
    },
    beforeDestroy() {},
};
</script>
